import React, { Component } from 'react';
import axios from 'axios'
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { CSVLink } from "react-csv";

import '../App.css';
import LoadingControl from '../controls/Loading';
import SuppliesHistoryTableEx from '../controls/SuppliesHistoryTableEx';
import DownloadButton from '../controls/DownloadButton';
import {objectWitOnlyProperties, getSafeArray} from '../utils/utils'

const { RangePicker } = DatePicker;

var toDate = dayjs();
var fromDate = dayjs().subtract(3, 'month');

class SuppliesHistoryPane extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: null,
      csvData: []
    };
  }

  getReportUrl(){
    var url = "/supplies_history";

     if (fromDate != null && toDate != null)
     {
        url = url + "?start=" + String(fromDate.unix()) + "&end=" + String(toDate.unix());
     } 

     return url;
  }
  
  transfromResponse(data)
  {
    data.map(record => {
      record.supplies.map((supply, index) => {
        supply["previousLevel"] = supply["currentLevel"] - supply["deltaLevel"];
        supply["id"] = index;
        return supply;
      });
      
      return record;
    });

    return data;
  }

  onDateRangeChange(date, dateString) {
    if (getSafeArray(date).length > 0)
    {
      fromDate = date[0];
      toDate = date[1];
    }
    else
    {
      fromDate = null;
      toDate = null;
    }

    this.update();
  }

  async getData() {
    const res = await axios(this.getReportUrl());
    return this.transfromResponse(getSafeArray(res.data));
  }

  update() {
    this.setState({isLoaded: false});

    this.getData()
    .then(res => {
      this.setState({ error: null, isLoaded: true, items: res });
    })
    .catch(err => {
      console.log(err);
      this.setState( {error: err, isLoaded: false, items: null });
    });
  }

  componentDidMount() {
    this.update();
  }

  getCVSData()
  {
      var raw_data = this.state.items;

      var sorted_data = [];

      var propertiesDevice = ['name', 'model', 'location', 'comment'] ;
      var propertiesChanges = ['description', 'changeDate', 'changePagesCount', 'currentLevel', 'previousLevel'];

      for (var i = 0; i < raw_data.length; i++)
      {
          var device = objectWitOnlyProperties(raw_data[i], propertiesDevice);

          for (var j = 0; j < raw_data[i].supplies.length; j++)
          {
              
              var change = objectWitOnlyProperties(raw_data[i].supplies[j], propertiesChanges);
              change["changeDate"] = dayjs(change["changeDate"]).format('LL');
              sorted_data.push(Object.assign({}, device, change));
          }
      }

      return sorted_data;

    }
  onCSVExportClick()
  {
    var sortedData = this.getCVSData();
    this.setState({ csvData: sortedData }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.link.click()}
    );
  }
  
  render() {
      if(this.state.error != null)
      {
        return (
          <div><h3>{this.state.error.message}</h3></div>
        );
      }
      else if (!this.state.isLoaded)
      {
        return (
          <div><LoadingControl/></div>
        );
      }
      else
      {  
        return (
          <div>
            <div className = "history-pane-header">
              <div className = "range-picker">
              <RangePicker onChange={(date, dateString) => this.onDateRangeChange(date, dateString)} 
                defaultValue={[fromDate, toDate]}/>
              </div>
              <CSVLink 
                data={this.state.csvData}
                separator=";"
                ref={(r) => this.csvLink = r}
                filename="supplies_history.csv"
                className="hidden"
                target="_blank">                
                </CSVLink>
              <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/>              
              <SuppliesHistoryTableEx data = {this.state.items}/>
            </div>
          </div>
        );         
      }
  }
}

export default SuppliesHistoryPane;